module.exports = __webpack_public_path__ + "img/content3-2.26560691.png";